<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'corporative'">
  <div class="card">
    <p-breadcrumb
      *ngIf="productCertificateId == 0"
      class="max-w-full breadcrumb-style"
      [model]="breadcrumbMenuItems2"
      [home]="breadcrumbHome">
    </p-breadcrumb>
    <p-breadcrumb
      *ngIf="productCertificateId > 0"
      class="max-w-full breadcrumb-style"
      [model]="breadcrumbMenuItems2Edit"
      [home]="breadcrumbHome">
    </p-breadcrumb>

    <div class="body-card py-3 px-4">
      <div class="header-card pt-0 mb-4">
        <div class="w-12 container-title">
          <h1 class="text-xl font-medium text-800 m-0">
            {{ productCertificateId > 0 ?
              ('UserPages.UserProductCertificates.Form.EditTitle' | translate) :
              ('UserPages.UserProductCertificates.Form.CreateTitle' | translate)
            }}
          </h1>
        </div>
      </div>

      <form [formGroup]="formGroup">
        <div class="p-fluid formgrid grid">
          <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
            <label for="name">{{'UserPages.UserProductCertificates.Form.NameLabel' | translate}} *</label>
            <input id="name" formControlName="name" type="text" required pInputText placeholder="{{'UserPages.UserProductCertificates.Form.NameLabel' | translate}}" class="custom-input"/>
            <small *ngIf="submit && formGroup.controls['name'].invalid" class="p-error">{{getErrorMessage('name')}}</small>
          </div>
          <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
            <label for="producerCode">{{'UserPages.UserProductCertificates.Form.ProducerCodeLabel' | translate}}</label>
            <input id="producerCode" formControlName="producerCode" type="text" pInputText placeholder="{{'UserPages.UserProductCertificates.Form.ProducerCodeLabel' | translate}}" class="custom-input"/>
          </div>
          <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
            <label for="certificateType">{{'UserPages.UserProductCertificates.Form.CertificateTypeLabel' | translate}} *</label>
            <p-dropdown inputId="certificateType" formControlName="productCertificateTypeId" [options]="productCertificateTypes" optionLabel="name" optionValue="id" placeholder="{{'UserPages.UserProductCertificates.Form.CertificateTypeLabel' | translate}}" class="custom-dropdown"></p-dropdown>
            <small *ngIf="submit && formGroup.controls['productCertificateTypeId'].invalid" class="p-error">{{getErrorMessage('productCertificateTypeId')}}</small>
          </div>
          <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
            <label for="issueDate">{{'UserPages.UserProductCertificates.Form.IssueDateLabel' | translate}} </label>
            <p-calendar
              id="issueDate"
              appendTo="body"
              formControlName="documentIssueDate"
              [showButtonBar]="true"
              [showIcon]="true"
              placeholder="{{'UserPages.UserProductCertificates.Form.IssueDateLabel' | translate}}"
              [showWeek]="true"
              [firstDayOfWeek]="1"
              class="custom-input-calendar"></p-calendar>
          </div>
          <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
            <label for="expirationDate">{{'UserPages.UserProductCertificates.Form.ExpireDateLabel' | translate}}</label>
            <p-calendar
              id="expirationDate"
              appendTo="body"
              formControlName="expirationDate"
              [showButtonBar]="true"
              [showIcon]="true"
              placeholder="{{'UserPages.UserProductCertificates.Form.ExpireDateLabel' | translate}}"
              [showWeek]="true"
              [firstDayOfWeek]="1"
              class="custom-input-calendar"></p-calendar>
          </div>
          <div class="field col-12">
            <label>{{'UserPages.UserProductCertificates.Form.LoadDocumentLabel' | translate}}</label>
            <p-fileUpload
              #fileUploader
              (onSelect)="onSelect($event)"
              [showUploadButton]="false"
              [multiple]="false"
              accept=".pdf"
              [maxFileSize]="5000000"
              chooseLabel="{{'UserPages.UserProductCertificates.Form.SelectFile' | translate}}"
              cancelLabel="{{'UserPages.UserProductCertificates.Form.CancelSelectFile' | translate}}"/>
          </div>
          <div class="col-12">
            <div class="grid pb-4" style="margin-top: 30px;">
              <div class="col-12 md:col-6 lg:col-6"></div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="grid p-fluid">
                  <div class="col-6">
                    <p-button label="{{'UserPages.UserProductCertificates.Form.BackButtonLabel' | translate}}" [disabled]="loading" styleClass="p-button-outlined" (click)="cancel()" class="custom-text-button"/>
                  </div>
                  <div class="col-6">
                    <p-button label="{{'UserPages.UserProductCertificates.Form.SaveButtonLabel' | translate}}" [loading]="loading" (click)="save()" class="custom-text-button"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</app-user-dashboard>


